import { SeatConfigurationSectionData } from '~client/model/admin/seat-configuration-section-data';
import { SelectFieldOption } from '~common/components/select.component';

const mapSections = (sections: SeatConfigurationSectionData[]): SelectFieldOption[] => {
  return sections.map(
    (section): SelectFieldOption => ({ name: section.name, value: section.code }),
  );
};

export const getOptionsForField = (
  available: SeatConfigurationSectionData[],
): SelectFieldOption[] => {
  // TODO(DMITRY): For now return all the sections
  return mapSections(available);
};



// WEBPACK FOOTER //
// ./view/components/details/offer-group-details/offer-group-section-picker.helper.ts